import { ShieldAlert } from "lucide-react";
const ErrorMessage = ({ message }) => {
    return (
        <div
            style={{
                textAlign: "center",
                padding: "60px 20px",
                fontSize: "16px",
                color: "#666",
                width: "100%",
                height: "100%",
                paddingTop: "100px",
            }}
        >
            <ShieldAlert size={64} stroke="red" />
            <p
                style={{
                    marginTop: "20px",
                    color:"#FF4500"
                }}
            >
                <strong style={{ color: "red" }}>ERROR: </strong>
                {message}
            </p>
        </div>
    );
};
export default ErrorMessage;
